<template>
  <collapse>
    <template v-if="hasError === true">
      <div class="error form-text text-red font-weight-midbold">
        <template v-for="error in errorMessages">
          <div v-if="typeof error !== 'object'">
            <template v-if="$slots.default">
              <slot name="default" :error="error"/>
            </template>

            <template v-else>
              <div class="error__message" :key="error">
                <clear-icon class="mr-2 d-inline" style="margin-bottom: 2px;"/>
                {{ error }}
              </div>
            </template>
          </div>
        </template>
      </div>
    </template>
  </collapse>
</template>

<script setup>
  import Collapse from '@/components/transitions/collapse';
  import ClearIcon from '@/components/icons/clear';
  import { useFieldErrors } from '@/composables/field-errors';

  const props = defineProps({
    errors: {
      type: Object,
      default: null,
    },

    errorName: {
      type: [String, Array],
      default: null,
    },
  });

  const { hasError, errorMessages } = useFieldErrors(props.errors, props.errorName);
</script>
